export const GLOBAL_ADD_TO_BAG_MODAL_LABELS = 'global.addedToBagModal';

export const preOrderAndGiftCardWarningMessage = 'lbl_preorder_giftcard_warning';
export const couponsError = 'lbl_checkoutmodal_couponError';
export const preOrderWarningMessage = 'lbl_preorder_warning';
export const giftCardWarningMessage = 'lbl_giftcard_warning';
export const vmpWarningMessage = 'lbl_vmp_warning';
export const bossInEligibleWarningMessage = 'lbl_boss_ineligible_warning';

export const lblCtaViewBag = 'lbl_cta_viewBag';
export const lblCtaCheckout = 'lbl_cta_checkout';
export const lblHeaderAddedToBag = 'lbl_header_addedToBag';
export const lblInfoColor = 'lbl_info_color';
export const lblInfoSize = 'lbl_info_size';
export const lblInfoQty = 'lbl_info_Qty';
export const lblInfoPrice = 'lbl_info_price';
export const lblInfoPointYouCanEarn = 'lbl_info_pointYouCanEarn';
export const lblInfoSubTotal = 'lbl_info_subTotal';
export const lblInfoTotalRewardsInBag = 'lbl_info_totalRewardsInBag';
export const lblInfoTotalNextRewards = 'lbl_info_totalNextRewards';
export const lblBossBannerSubHeadingDefault = 'lbl_bossBanner_subHeadingDefault';
export const lblBossBannerNoRush = 'lbl_bossBanner_noRush';
export const name = 'name';
export const lblCtaKeepShopping = 'lbl_cta_keepShopping';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblHeadingStyleWith = 'lbl_heading_styleWith';
export const lblPickupInsteadHeading = 'lbl_pickup_instead_heading';
export const lblPickupInsteadHeadingSuccess = 'lbl_pickup_instead_heading_success';
export const lblPickupInsteadFreeOrder = 'lbl_pickup_instead_free_order';
export const lblPickupInsteadItemAdded = 'lbl_pickup_instead_item_added';
export const lblPickupInsteadBtnText = 'lbl_pickup_instead_btn_text';
export const lblPickupInsteadHeadingError = 'lbl_pickup_instead_heading_error';
export const lblPickupInsteadMsgError = 'lbl_pickup_instead_msg_error';
export const lblOrdersLoadMore = 'lbl_orders_load_more';
export const lblItemAddedToBag = 'lbl_item_added_to_bag';
export const lblBagSubTotalRedesign = 'lbl_bag_sub_total_redesign';
export const lblKeepShoppingRedesign = 'lbl_keep_shopping_redesign';
export const lblWeFoundTheseSimilarItems = 'lbl_we_found_these_similar_items';
export const lblRewardLoyaltyPart1Redesign = 'lbl_reward_loyalty_part1_redesign';
export const lblRewardLoyaltyPart2Redesign = 'lbl_reward_loyalty_part2_redesign';
export const lblPointsLoyaltyPart1Redesign = 'lbl_points_loyalty_part1_redesign';
export const lblPointsLoyaltyPart2Redesign = 'lbl_points_loyalty_part2_redesign';
export const lblBnplaInterestFreeText = 'lbl_bnpla_interest_free_text';
export const lblBnplaAvailableOverText = 'lbl_bnpla_available_over_text';
export const lblBnplaNotAvailableText = 'lbl_bnpla_not_available_text';
export const lblBnplaAvailableRangeText = 'lbl_bnpla_available_range_text';
export const lblCtaViewShoppingBag = 'lbl_cta_viewShoppingBag';
export const lblInfoItemPoints = 'lbl_info_item_points';
export const lblPickupInsteadReadyHeading = 'lbl_pickup_instead_ready_heading';
export const lblPickupInsteadFromStore = 'lbl_pickup_instead_from_store';
export const lblBnplaDirectedAfterpay = 'lbl_bnpla_directed_afterpay';
export const lblHeadingFbt = 'lbl_heading_fbt';
export const lblItemsAddedToBag = 'lbl_items_added_to_bag';
export const lblItemsNotAddedToBag = 'lbl_items_not_added_to_bag';
export const lblOopsAddedToBag = 'lbl_oops_added_to_bag';
export const lblOtherPayOptionsAddedToBag = 'lbl_other_pay_options_added_to_bag';
export const lblGiftcardWarning = 'lbl_giftcard_warning';
export const lblBagSubTotalAddtobagredesign = 'lbl_bag_sub_total_addtobagredesign';
export const lblPreorderWarning = 'lbl_preorder_warning';
export const lblPreorderGiftcardWarning = 'lbl_preorder_giftcard_warning';
export const lblVmpWarning = 'lbl_vmp_warning';
export const lblBossIneligibleWarning = 'lbl_boss_ineligible_warning';
export const lblRememberPreference = 'lbl_remember_preference';
export const lblFeedbackModalAlertTitle = 'lbl_feedbackModal_alertTitle';
export const lblFeedbackModalAlertMessage = 'lbl_feedbackModal_alertMessage';
export const lblFeedbackModalAlertPositiveText = 'lbl_feedbackModal_alertPositiveText';
export const lblFeedbackModalAlertNegativeText = 'lbl_feedbackModal_alertNegativeText';
export const lblEnjoyingAppModalAlertTitle = 'lbl_enjoyingAppModal_alertTitle';
export const lblEnjoyingAppModalAlertMessage = 'lbl_enjoyingAppModal_alertMessage';
export const lblEnjoyingAppModalAlertNegativeEmojiCode =
  'lbl_enjoyingAppModal_alertNegativeEmojiCode';
export const lblEnjoyingAppModalAlertPositiveEmojiCode =
  'lbl_enjoyingAppModal_alertPositiveEmojiCode';
export const lblEnjoyingAppModalAlertNegativeOptionText =
  'lbl_enjoyingAppModal_alertNegativeOptionText';
export const lblEnjoyingAppModalAlertPositiveOptionText =
  'lbl_enjoyingAppModal_alertPositiveOptionText';
export const lblRateUsModalAlertTitile = 'lbl_rateUsModal_alertTitile';
export const lblRateUsModalAlertMessage = 'lbl_rateUsModal_alertMessage';
export const lblRateUsModalAlertPositiveOptionText = 'lbl_rateUsModal_alertPositiveOptionText';
export const lblRateUsModalAlertNegativeOptionText = 'lbl_rateUsModal_alertNegativeOptionText';
export const lblFeedbackModalAlertTitleFirstTime = 'lbl_feedbackModal_alertTitle_firstTime';
export const checkLbl = 'check_lbl';
export const lblEnjoyingAppModalAlertMessageSecondVisist =
  'lbl_enjoyingAppModal_alertMessage_second_visist';
export const lblFeedbackEmailApp = 'lbl_feedback_email_app';
export const lblFeedbackAlertMessageFirstTime = 'lbl_feedback_alert_message_first_time';
export const lblFeedbackEmailBody = 'lbl_feedback_email_body';

export const GlobalAddToBagLabels = {
  global: {
    addedToBagModal: {
      [preOrderAndGiftCardWarningMessage]:
        'Pre-Orders and Gift cards are ineligible for Ship To Store.  Continue to checkout to ship all items to your home or  go back to bag to save the gift card items for later',
      [preOrderWarningMessage]:
        'Pre Orders are ineligible for Ship To Store. Continue to checkout to ship all items to your home or go back to bag to save the gift card items for later.',
      [giftCardWarningMessage]:
        'Gift Cards are ineligible for Ship To Store. Continue to checkout to ship all items to your home or go back to bag to save the gift card items for later.',
      [vmpWarningMessage]:
        'One or more items in your cart are ineligible for Ship To Store. Continue to checkout to ship all items to your home or go back to bag to save those ineligible items for later.',
      [bossInEligibleWarningMessage]:
        'Some items are ineligible for No Rush Pickup. Continue to checkout to ship all items to your home or go back to bag to remove the items.',
      [lblCtaViewBag]: 'View Bag',
      [lblCtaCheckout]: 'Checkout',
      [lblHeaderAddedToBag]: 'ADDED TO BAG',
      [lblInfoColor]: 'Color',
      [lblInfoSize]: 'Size',
      [lblInfoQty]: 'Qty',
      [lblInfoPrice]: 'Price',
      [lblInfoPointYouCanEarn]: 'Points you can earn on item(s)',
      [lblInfoSubTotal]: 'Bag Subtotal (#items items)',
      [lblInfoTotalRewardsInBag]: 'Total My Place Reward Points in Bag',
      [lblInfoTotalNextRewards]: 'Total Points To Next Reward',
      [lblBossBannerSubHeadingDefault]: 'Simply choose “#type” in your bag before checking out.',
      [lblBossBannerNoRush]: 'NO RUSH Pick Up ',
      [name]: 'NEED_HELP_DATA',
      [lblCtaKeepShopping]: 'KEEP SHOPPING ',
      [lblYouMayAlsoLike]: 'YOU MAY ALSO LIKE ',
      [lblHeadingStyleWith]: 'STYLE WITH ',
      [lblPickupInsteadHeading]: 'Pick it up instead! ',
      [lblPickupInsteadHeadingSuccess]: 'Order pickup added to bag! ',
      [lblPickupInsteadFreeOrder]: 'at ',
      [lblPickupInsteadItemAdded]: 'Pick it up at ',
      [lblPickupInsteadBtnText]: 'Pick Up ',
      [lblPickupInsteadHeadingError]: 'Order pickup unsuccessful ',
      [lblPickupInsteadMsgError]:
        'Something went wrong, but your item is still available to ship to your home ',
      [lblOrdersLoadMore]: 'LOAD MORE ',
      [lblItemAddedToBag]: 'Item Added To Bag!',
      [lblBagSubTotalRedesign]: 'Bag Subtotal',
      [lblKeepShoppingRedesign]: 'Keep Shopping',
      [lblWeFoundTheseSimilarItems]: 'We Found These Similar Items',
      [lblRewardLoyaltyPart1Redesign]: "You've qualified for a",
      [lblRewardLoyaltyPart2Redesign]: 'reward!',
      [lblPointsLoyaltyPart1Redesign]: 'You’ll earn',
      [lblPointsLoyaltyPart2Redesign]: 'points on this purchase!',
      [lblBnplaInterestFreeText]: 'or 4 interest-free payments of $#placeholder with ',
      [lblBnplaAvailableOverText]: ' available for orders $#placeholder+',
      [lblBnplaNotAvailableText]: ' is not available for this purchase. ',
      [lblBnplaAvailableRangeText]: ' available for orders between $#placeholder - $#placeholder1 ',
      [lblCtaViewShoppingBag]: 'View Shopping Bag',
      [lblInfoItemPoints]: ' pts',
      [lblPickupInsteadReadyHeading]: 'Pick up Instead',
      [lblPickupInsteadFromStore]: 'with free order pick up at ',
      [lblBnplaDirectedAfterpay]:
        'You will be directed to Afterpay once you submit your order on the next step',
      [lblHeadingFbt]: 'Frequently Bought Together',
      [lblItemsAddedToBag]: 'Items Added To Bag',
      [lblItemsNotAddedToBag]: 'Items Not Added To Bag',
      [lblOopsAddedToBag]: 'Oops!',
      [lblOtherPayOptionsAddedToBag]: 'Other payment options',
      [lblGiftcardWarning]:
        'Gift Cards are ineligible for No Rush Pickup.  Continue to checkout to ship all items to your home or  go back to bag to save the gift card items for later.',
      [lblBagSubTotalAddtobagredesign]:
        "<span class='add-to-bag-subtotal-redesign'>Subtotal</span> (_itemscount_ Items)",
      [lblPreorderWarning]:
        'Pre Orders are ineligible for No Rush Pickup.  Continue to checkout to ship all items to your home or  go back to bag to save the gift card items for later.',
      [lblPreorderGiftcardWarning]:
        'Pre-Orders and Gift cards are ineligible for No Rush Pickup.  Continue to checkout to ship all items to your home or  go back to bag to save the gift card items for later.',
      [lblVmpWarning]:
        'VMP are ineligible for No Rush Pickup.  Continue to checkout to ship all items to your home or  go back to bag to save the VMP items for later.',
      [lblBossIneligibleWarning]:
        'Some items are ineligible for No Rush Pickup. Continue to checkout to ship all items to your home or go back to bag to remove the items.',
      [lblRememberPreference]: 'Remember my size',
      [lblFeedbackModalAlertTitle]: 'Your opinion matters!',
      [lblFeedbackModalAlertMessage]:
        'Let us know how we can improve your experience by emailing us at',
      [lblFeedbackModalAlertPositiveText]: 'Send us a note',
      [lblFeedbackModalAlertNegativeText]: 'Maybe later',
      [lblEnjoyingAppModalAlertTitle]: 'Enjoying this App?',
      [lblEnjoyingAppModalAlertMessage]:
        "Hi there! We'd love to know if you're enjoying this experience.",
      [lblEnjoyingAppModalAlertNegativeEmojiCode]: '0x1F641',
      [lblEnjoyingAppModalAlertPositiveEmojiCode]: '0x1F917',
      [lblEnjoyingAppModalAlertNegativeOptionText]: 'Not Really',
      [lblEnjoyingAppModalAlertPositiveOptionText]: 'Yes!',
      [lblRateUsModalAlertTitile]: 'Thanks for shopping with us!',
      [lblRateUsModalAlertMessage]:
        'Spread the love and help us to improve our experience by leaving a review in the app store!',
      [lblRateUsModalAlertPositiveOptionText]: 'Next time',
      [lblRateUsModalAlertNegativeOptionText]: 'Rate Us',
      [lblFeedbackModalAlertTitleFirstTime]: 'Oh no!',
      [checkLbl]: 'December content',
      [lblEnjoyingAppModalAlertMessageSecondVisist]:
        'We appreciate you and work constantly to improve this experience',
      [lblFeedbackEmailApp]: 'mobileapps@childrensplace.com',
      [lblFeedbackAlertMessageFirstTime]: 'Oh no!',
      [lblFeedbackEmailBody]: 'Mobile App Feedback',
    },
  },
};
